(function() {

  'use strict';

  function UploadResource($resource, PUBLIC_API, URLAPIPEDIDO) {
    return $resource(PUBLIC_API, {}, {
      getLiberacao: {
        method: 'POST',
        url: PUBLIC_API + '/planilha/available'
      },
      proccessFile: {
        method: 'POST',
        url: URLAPIPEDIDO + '/v1/pedidos/planilha/processar'
      },
      proccessXMLFile: {
        method: 'POST',
        url: URLAPIPEDIDO + '/v1/pedidos/xml/processar'
      },
      proccessFileAsync: {
        method: 'POST',
        url: URLAPIPEDIDO + '/v2/pedidos/planilha/processar'
      },
      proccessXMLFileAsync: {
        method: 'POST',
        url: URLAPIPEDIDO + '/v2/pedidos/xml/processar'
      },
      listarJobs: {
        isArray:true,
        method: 'GET',
        url: URLAPIPEDIDO + '/v1/jobs/arquivos'
      }
    });
  }

  angular.module('mandaeApp')
    .factory('UploadResource', UploadResource);

})();
